import { createReducer } from "reduxsauce";

export const initialState = {
  profile: null,
  brand: null,
  uid: "",
  users: [],
  renters: [],
  properties: [],
  unreads: [],
  brand_unreads: [],
  super_unreads: [],
  super_contents: null,
  super_questions: [],
  allRetailers: [],
  myRole: "",
  hasPlayed: false,
};

const saveProfileReducer = (state, action) => ({
  ...state,
  profile: action.profile,
});
const savePropertiesReducer = (state, action) => ({
  ...state,
  properties: action.properties,
});
const saveUIDReducer = (state, action) => ({
  ...state,
  uid: action.uid,
});

const saveUsersReducer = (state, action) => ({
  ...state,
  users: action.users,
});

const saveBrandReducer = (state, action) => ({
  ...state,
  brand: action.brand,
});

const saveRentersReducer = (state, action) => ({
  ...state,
  renters: action.renters,
});

const saveUnreadSupportMessagesReducer = (state, action) => {
  return {
    ...state,
    unreads: action.unreads,
  };
};

const saveUnreadMessageFromSuperReducer = (state, action) => {
  return {
    ...state,
    brand_unreads: action.unreads,
  };
};
const saveSuperUnreadMessagesReducer = (state, action) => {
  return {
    ...state,
    super_unreads: action.unreads,
  };
};
const saveSuperContentsReducer = (state, action) => {
  return {
    ...state,
    super_contents: action.super_contents,
  };
};
const saveAllRetailersReducer = (state, action) => {
  return {
    ...state,
    allRetailers: action.allRetailers,
  };
};
const saveSuperQuestionsReducer = (state, action) => {
  return {
    ...state,
    super_questions: action.super_questions,
  };
};
const saveMyRoleReducer = (state, action) => {
  return {
    ...state,
    myRole: action.myRole,
  };
};
const removeAllReducer = (state, _action) => ({
  ...state,
  profile: null,
  properties: [],
  renters: [],
  brand: null,
  uid: null,
  unreads: [],
  brand_unreads: [],
  super_unreads: [],
  super_questions: [],
  allRetailers: [],
  myRole: "",
  hasPlayed: false,
});

const notificationSoundPlayedReducer = (state, action) => {
  return { ...state, hasPlayed: action.hasPlayed };
};

//selector

export const SuperContentSelector = (state) => state.super_contents;
export const SuperQuestionsSelector = (state) => state.super_questions;
export const allRetailersSelector = (state) => state.allRetailers;
const actionHandlers = {
  SAVE_PROFILE: saveProfileReducer,
  SAVE_PROPERTIES: savePropertiesReducer,
  SAVE_BRAND: saveBrandReducer,
  SAVE_UID: saveUIDReducer,
  SAVE_USERS: saveUsersReducer,
  SAVE_RENTERS: saveRentersReducer,
  SAVE_UNREADS: saveUnreadSupportMessagesReducer,
  SAVE_BRAND_UNREADS: saveUnreadMessageFromSuperReducer,
  SAVE_SUPER_UNREADS: saveSuperUnreadMessagesReducer,
  SAVE_SUPER_CONTENTS: saveSuperContentsReducer,
  SAVE_ALL_RETAILERS: saveAllRetailersReducer,
  SAVE_SUPER_QUESTIONS: saveSuperQuestionsReducer,
  SAVE_MY_ROLE: saveMyRoleReducer,
  REMOVE: removeAllReducer,
  SET_NOTIFICATION_SOUND_PLAYED: notificationSoundPlayedReducer,
};
export default createReducer(initialState, actionHandlers);



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js